<sw-page class="tdcp-customer-price-list">
    <template #smart-bar-header>
        <h2>{{ $tc('tdcp-customer-prices.list.title') }}</h2>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :items="items"
            :repository="repository"
            :columns="columns"
            :isLoading="isLoading"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            detail-route="tdcp.customer.prices.detail"
            :show-selection="false"
            :allow-view="true"
            :allow-edit="false"
            :allow-delete="false"
            identifier="tdcp-customer-price-list"
            @page-change="onPageChange"
        >
            <template #column-customer.firstName="{ item }">
                {{ item.customer ? item.customer.firstName + ' ' + item.customer.lastName : '-' }}
            </template>

            <template #column-customer.email="{ item }">
                {{ item.customer ? item.customer.email : '-' }}
            </template>

            <template #column-customer.company="{ item }">
                {{ item.customer ? item.customer.company : '-' }}
            </template>

            <template #column-price="{ item }">
                {{ formatPrice(item.price) }}
            </template>
        </sw-entity-listing>

        <sw-empty-state
            v-if="!isLoading && items && items.total === 0"
            :title="$tc('tdcp-customer-prices.list.empty')"
            icon="regular-currency-euro"
        />
    </template>
</sw-page>
